import React from 'react';
import { Modal } from 'antd';
import { FlexBoxFullWidthCenter, FlexBoxFullWidthHeight } from 'styles';
import { useChannelTalk } from 'hooks';
import { ChannelTalkButton } from 'components';

const PreparationModal = ({ title, open, onClose }) => {
  useChannelTalk(true, true);

  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null} bodyStyle={{ height: 712 }}>
      <FlexBoxFullWidthHeight direction="column" gap="55px" justify="space-evenly">
        <FlexBoxFullWidthCenter direction="column">
          <div>아직 심사중입니다.</div>
          <div>자세한 내용은 채팅상담을 통해</div>
          <div>문의해주세요</div>
        </FlexBoxFullWidthCenter>
        <div className="custom-channel-container">
          <ChannelTalkButton />
        </div>
      </FlexBoxFullWidthHeight>
    </Modal>
  );
};

export default PreparationModal;
